export { default as CodeSnippet } from './code-snippet.jsx';
export { default as Footer } from './footer.jsx';
export { default as LocaleSelector } from './locale-selector.jsx';
export { default as Main } from './main.jsx';
export { default as Meta } from './meta.jsx';
export { default as Navigation } from './navigation.jsx';
export { default as Search } from './search.jsx';
export { default as SideBar } from './side-bar.jsx';
